import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Constants } from '../../common/constants/constants';
import { ToastService } from '../../component-services/toast/toast.service';

@Injectable({
	providedIn: 'root'
})
export class AccountService {

	constructor(private http: HttpClient,
		private alertController: AlertController,
		private router: Router,
		private toast: ToastService) { }

	authenticate(loginDto) {
		let formData: any = `grant_type=password&username=${loginDto.email.trim()}&password=${loginDto.pwd}&client_id=mypad-mobile`;
		return this.http.post(`${environment.httpBase}/token`, formData, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Accept': 'application/json'
			}
		}).toPromise();
	}

	getUser() {
		return this.http.get(`${environment.baseUrl}/user`).toPromise();
	}

	async patchUser(userId: number, obj: any) {
		return this.http.patch(`${environment.baseUrl}/user/${userId}`, obj).toPromise();
	}

	async showLoginAlert() {
		const alert = await this.alertController.create({
			header: 'Authorization Status',
			message: 'Please Login to continue',
			buttons: [
				{
					text: 'Okay',
					handler: () => {
						this.router.navigate(['home']);
					}
				}
			]
		});
		await alert.present();

	}
}
